import { HowItWorksIcon1, HowItWorksIcon2, HowItWorksIcon3, QuestionIcon } from '@/components/EcoCredits/Svg';
import LoginFormModal from '@/components/LoginFormModal';
import Link from '@/components/utils/Link';
import { loginUser } from '@/utils/cookie';
import { signupCookie } from '@/utils/cookies/signupCookie';
import { isMembersFestival } from '@/utils/membersFestival';
import { Tooltip } from 'antd-v5';
import EditorLink from 'lowcode/components/EditorLink';
import { getLang } from 'lowcomp/plugins/member/utils';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { TextLang } from '../TextLang';
import styled from './index.module.scss';

const QuestionIconGray = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 2.80005C14.5403 2.80005 16.8403 3.82993 18.5052 5.49486C20.1702 7.15979 21.2001 9.45978 21.2001 12C21.2001 14.5403 20.1702 16.8403 18.5052 18.5052C16.8403 20.1702 14.5403 21.2001 12 21.2001C9.45978 21.2001 7.15979 20.1702 5.49486 18.5052C3.82993 16.8403 2.80005 14.5403 2.80005 12C2.80005 9.45978 3.82993 7.15979 5.49486 5.49486C7.15979 3.82993 9.45978 2.80005 12 2.80005Z"
            stroke="#ADAFB3"
            strokeWidth="1.6"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1437 15.3957C11.5619 15.3957 11.0903 15.8667 11.0903 16.4478C11.0903 17.0289 11.5619 17.5 12.1437 17.5C12.7256 17.5 13.1972 17.0289 13.1972 16.4478C13.1972 15.8667 12.7256 15.3957 12.1437 15.3957ZM12.107 6.5C11.4668 6.5 10.8975 6.6348 10.3998 6.90539C9.89999 7.17715 9.50902 7.54332 9.22851 8.00416C8.99532 8.39204 8.85472 8.81376 8.80755 9.26416L8.79175 9.50252C8.79175 9.6355 8.83246 9.74966 8.91297 9.83408C8.97099 9.89491 9.04163 9.93214 9.12253 9.94695L9.20675 9.95433H9.84828C9.96604 9.95433 10.067 9.92016 10.1476 9.8486C10.2093 9.79391 10.2554 9.72066 10.2868 9.63148L10.3133 9.53709L10.3514 9.34319C10.4511 8.90663 10.6261 8.58065 10.8767 8.35545C11.1653 8.09603 11.5609 7.96421 12.0669 7.96421C12.5 7.96421 12.8742 8.08358 13.1936 8.32153C13.5062 8.54847 13.6566 8.84403 13.6566 9.22222C13.6566 9.47948 13.5858 9.71491 13.4418 9.93303C13.353 10.0675 13.2335 10.224 13.0835 10.4023L12.8354 10.6859L12.6943 10.8399C12.2611 11.3036 11.9306 11.7166 11.7026 12.0801C11.4987 12.405 11.3755 12.784 11.3327 13.2117L11.3179 13.4296L11.3177 14.0013C11.3177 14.1262 11.3594 14.2353 11.439 14.3189C11.4964 14.3791 11.5645 14.4166 11.6406 14.4316L11.7194 14.4391H12.4411C12.5562 14.4391 12.6555 14.4024 12.7344 14.3262C12.7929 14.2698 12.8369 14.1949 12.8671 14.1037L12.8928 14.0072L12.8963 14.0052L12.8973 13.8897L12.9057 13.6747L12.9226 13.3961C12.9474 13.1062 13.0367 12.8482 13.192 12.6167C13.3292 12.4048 13.5254 12.1526 13.7805 11.8608L13.9406 11.6809C14.3559 11.2171 14.6686 10.8084 14.8791 10.4535C15.0988 10.0827 15.2084 9.64292 15.2084 9.13813C15.2084 8.68004 15.0943 8.25089 14.8668 7.85282C14.6394 7.44598 14.2875 7.12117 13.8117 6.87601C13.3495 6.62467 12.7811 6.5 12.107 6.5Z"
            fill="#ADAFB3"
        />
    </svg>
);

interface IPorps {
    isLogin: boolean;
    loginType: 'page' | 'modal';
}
const HowItWorks: React.FC<IPorps> = ({ isLogin, loginType = 'page' }) => {
    const { locale = 'us' } = useRouter();
    const t = getLang(TextLang, locale);
    const mfStatus = isMembersFestival(locale);
    const [href, setHref] = useState('');
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showLoginModal1, setShowLoginModal1] = useState(false);
    const [isClient, setIsClient] = useState(false);

    const data = [
        {
            key: '1',
            icon: <HowItWorksIcon1 />,
            title: t('sign_up'),
            text: t('sign_up_desc'),
        },
        {
            key: '2',
            icon: <HowItWorksIcon2 />,
            title: t('earn_points'),
            text: t('earn_points_desc'),
        },
        {
            key: '3',
            icon: <HowItWorksIcon3 />,
            title: t('redeem_points'),
            text: t('redeem_points_desc'),
            question: t('more_benefits_question'),
        },
    ];

    useEffect(() => {
        const userInfo = loginUser();
        setIsClient(true);
        setHref(window.location.href);
    }, []);

    return (
        <div
            className={`${styled.HowItWorks} main-page  GtmModuleData-section`}
            data-section-id={'Member-HowItWorks'}
            data-section-title={t('how_it_works')}
            id="HOW_IT_WORKS"
        >
            <div className="wtep-wrapper">
                <h5 className="ecocredits-title">
                    {t('how_it_works')}
                    <Link href={`https://${locale}.ecoflow.com/pages/rewards-guide`}>
                        <QuestionIconGray />
                    </Link>
                </h5>

                <ul className="list">
                    {data.map((item) => (
                        <li key={item.key} className="item">
                            <div className="icon">{item.icon}</div>
                            <div>
                                <h6 className="item-title">
                                    {item.title}
                                    {item.question && (
                                        <Tooltip overlayClassName={`${styled.tooltips}`} title={item.question}>
                                            <QuestionIcon />
                                        </Tooltip>
                                    )}
                                </h6>
                                <p className="item-text">{item.text}</p>
                            </div>
                        </li>
                    ))}
                </ul>
                {!isLogin && (
                    <div className="bottom-btns">
                        {loginType === 'modal' ? (
                            <EditorLink
                                className="btn-text-link black GtmModuleData-btn-href"
                                target="_self"
                                onClick={() => {
                                    signupCookie?.({
                                        sector_name: 'top banner_Join the EcoCredits reward program',
                                        entry_position: 1,
                                    });
                                    setShowLoginModal1(true);
                                }}
                            >
                                {t('join_now')}
                            </EditorLink>
                        ) : (
                            <EditorLink
                                className="btn-text-link black GtmModuleData-btn-href"
                                href={`/${locale}/register?redirect=${encodeURIComponent(href)}`}
                                target="_self"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'signup_start',
                                    entry_type: 'fixed entry',
                                    entry_name: t('join_title'),
                                    entry_position: 'none',
                                    source_channel: 'Website',
                                }}
                                onClick={() =>
                                    signupCookie?.({
                                        sector_name: t('join_title'),
                                        entry_position: 1,
                                    })
                                }
                            >
                                {t('join_now')}
                            </EditorLink>
                        )}
                        {loginType === 'modal' ? (
                            <EditorLink
                                className="btn-text-link white GtmModuleData-btn-href"
                                target="_self"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'activity_join_login',
                                    button_name: 'Join the EcoCredits reward program _Log In',
                                }}
                                onClick={() => {
                                    setShowLoginModal(true);
                                }}
                            >
                                {t('login')}
                            </EditorLink>
                        ) : (
                            <EditorLink
                                className="btn-text-link white GtmModuleData-btn-href"
                                href={`/${locale}/login?redirect=${encodeURIComponent(href)}`}
                                target="_self"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'signup_start',
                                    entry_type: 'fixed entry',
                                    entry_name: t('join_title'),
                                    entry_position: 'none',
                                    source_channel: 'Website',
                                }}
                                onClick={() =>
                                    signupCookie?.({
                                        sector_name: t('join_title'),
                                        entry_position: 1,
                                    })
                                }
                            >
                                {t('login')}
                            </EditorLink>
                        )}
                        {/* <EditorLink className="btn-text-link black GtmModuleData-btn-href" href={`https://www.ecoflow.com/${locale}/register`} target="_blank">
                            {t('join_now')}
                        </EditorLink>
                        <EditorLink className="btn-text-link white GtmModuleData-btn-href" href={`https://www.ecoflow.com/${locale}/login`} target="_blank">
                            {t('login')}
                        </EditorLink> */}
                    </div>
                )}
            </div>
            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        type="passwordless"
                    />,
                    document.body,
                )}

            {isClient &&
                showLoginModal1 &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal1}
                        onCancel={() => {
                            setShowLoginModal1(false);
                        }}
                        isRegister={true}
                        type="passwordless"
                    />,
                    document.body,
                )}
        </div>
    );
};

export default HowItWorks;
